// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Css from "@emotion/css";
import * as Core from "@material-ui/core";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../../context/user/User_Context.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../../types/App_Types_Result.bs.js";
import * as App_TopMenu_Notifications_Api$DvmAdminFrontendFr from "./App_TopMenu_Notifications_Api.bs.js";
import * as App_TopMenu_Notifications_Item$DvmAdminFrontendFr from "./App_TopMenu_Notifications_Item.bs.js";
import * as App_TopMenu_Notifications_Allocations_Modal$DvmAdminFrontendFr from "./App_TopMenu_Notifications_Allocations_Modal.bs.js";

var paddingRight = Css.css({
      paddingRight: "1rem"
    });

function App_TopMenu_Notifications(Props) {
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$1 = match[0];
  var userManager = match$1.userManager;
  var selectedRole = match$1.selectedRole;
  var match$2 = React.useState(function () {
        return false;
      });
  var setModal = match$2[1];
  var match$3 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setResult = match$3[1];
  var result = match$3[0];
  var match$4 = React.useState(function () {
        return /* [] */0;
      });
  var setNotifications = match$4[1];
  var notifications = match$4[0];
  var refetch = function (param) {
    App_TopMenu_Notifications_Api$DvmAdminFrontendFr.fetchNotifications(userManager, setResult, selectedRole);
  };
  React.useEffect((function () {
          App_TopMenu_Notifications_Api$DvmAdminFrontendFr.fetchNotifications(userManager, setResult, selectedRole);
        }), [url]);
  React.useEffect((function () {
          App_Types_Result$DvmAdminFrontendFr.mapWithDefault(result, undefined, (function (x) {
                  Curry._1(setNotifications, (function (param) {
                          return x;
                        }));
                }));
        }), [result]);
  return React.createElement(React.Fragment, undefined, React.createElement(Core.Box, {
                  className: paddingRight,
                  children: Belt_List.toArray(Belt_List.map(notifications, (function (notification) {
                              return React.createElement(App_TopMenu_Notifications_Item$DvmAdminFrontendFr.make, {
                                          refetch: refetch,
                                          notification: notification,
                                          setModal: setModal
                                        });
                            }))),
                  alignItems: "center",
                  display: "flex",
                  gridColumnGap: "10px"
                }), match$2[0] ? React.createElement(App_TopMenu_Notifications_Allocations_Modal$DvmAdminFrontendFr.make, {
                    onClose: (function (param) {
                        App_TopMenu_Notifications_Api$DvmAdminFrontendFr.fetchNotifications(userManager, setResult, selectedRole);
                        Curry._1(setModal, (function (param) {
                                return false;
                              }));
                      }),
                    refetch: refetch,
                    notifications: notifications
                  }) : null);
}

var make = App_TopMenu_Notifications;

export {
  paddingRight ,
  make ,
}
/* paddingRight Not a pure module */
